(()=>{
  const initialize=scope=>{
    scope.querySelectorAll('[data-v-track]').forEach(track=>{
      if(track.dataset.visualReady)return;
      track.dataset.visualReady='true';
      const section=track.closest('.v-shop');
      const controls=section.querySelector('[data-v-rail-controls]');
      const previous=controls.querySelector('[data-v-prev]');
      const next=controls.querySelector('[data-v-next]');
      const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      const update=()=>{
        const hasOverflow=track.scrollWidth>track.clientWidth+4;
        controls.hidden=!hasOverflow;
        previous.disabled=track.scrollLeft<4;
        next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;
        previous.setAttribute('aria-disabled',String(previous.disabled));
        next.setAttribute('aria-disabled',String(next.disabled));
      };
      const move=direction=>{
        const card=track.querySelector('[data-product-card]:not([hidden])');
        const distance=card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap):track.clientWidth;
        track.scrollBy({left:distance*direction,behavior:motion.matches?'instant':'smooth'});
      };
      previous.addEventListener('click',()=>move(-1));
      next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});
      section.querySelectorAll('[data-category-filter]').forEach(button=>button.addEventListener('click',()=>{track.scrollTo({left:0,behavior:'instant'});requestAnimationFrame(update);}));
      if('ResizeObserver'in window)new ResizeObserver(update).observe(track);
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
